import React, { useEffect, useState } from "react";
import { Typography, Grid, Box, Paper } from "@mui/material";
import { Button, Input, notification, Select, Table } from "antd";
import dayjs from "dayjs";
import { CommissionEarnedIcon, TicketsSoldIcon } from "../../../../Svg/icons";
import { AllTypoFontStyles } from "../../../../Styles/styles";
import { useEventDetailMutation } from "../../../../Redux/apis/ApiSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

import { useNavigate } from "react-router-dom";

const columns = [
  {
    title: "Member name",
    dataIndex: "memberName",
    key: "memberName",
    width: 150,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    width: 150,
  },
  {
    title: "Member Email",
    dataIndex: "email",
    key: "email",
    width: 150,
  },
  {
    title: "Member Phone",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    width: 150,
  },
  {
    title: "Ticket Type",
    dataIndex: "ticketType",
    key: "ticketType",
    width: 150,
  },
  {
    title: "Booked",
    dataIndex: "booked",
    key: "booked",
    align: "center",
    width: 150,
  },
];

const invitationColumn = [
  {
    title: <span style={{ whiteSpace: "nowrap" }}>Member Email</span>,
    dataIndex: "memberEmail",
    key: "memberEmail",
    width: 150,
  },
  {
    title: <span style={{ whiteSpace: "nowrap" }}>Name</span>,
    dataIndex: "memberName",
    key: "memberName",
    width: 170,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 120,
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
    width: 120,
  },
];
const referralColumns = [
  {
    title: <span style={{ whiteSpace: "nowrap" }}>Name</span>,
    dataIndex: "fullName",
    key: "fullName",
    width: 150,
    render: (text) => (
      <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {text}
      </div>
    ),
  },
  {
    title: <span style={{ whiteSpace: "nowrap" }}>Email</span>,
    dataIndex: "email",
    key: "email",
    width: 150,
    render: (text) => (
      <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {text}
      </div>
    ),
  },
  {
    title: <span style={{ whiteSpace: "nowrap" }}>Total Tickets</span>,
    dataIndex: "ticketsBooked",
    key: "ticketsBooked",
    width: 250,
    render: (text) => (
      <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {text}
      </div>
    ),
  },
];


const StatCard = ({ title, value }) => (
  <Paper
    sx={{
      textAlign: "center",
      padding: 1,
      marginBottom: 1,
      maxWidth: "100% !important",
    }}
  >
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        maxWidth: "100%",
      }}
    >
      <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{title}</Typography>
      <Typography variant="h4">{value}</Typography>
    </Box>
  </Paper>
);
const ImageGrid = ({ images }) => {
  // Limit to 4 images
  const displayImages = images.slice(0, 4);
  const extraCount = images.length - 4;

  return (
    <Box sx={{ position: "relative", padding: "1rem", width: "100%" }}>
      <Grid container spacing={1}>
        {displayImages.map((image, index) => (
          <Grid
            item
            xs={12} // Mobile: 1 image per row
            sm={6} // Tablets and above: 2 images per row
            key={index}
          >
            <Box
              component="img"
              src={image}
              alt={`Event image ${index + 1}`}
              sx={{
                width: "100%",
                height: { xs: "150px", sm: "120px", md: "100px" }, // Dynamic height
                objectFit: "cover",
                borderRadius: 2,
              }}
            />
          </Grid>
        ))}
      </Grid>

      {extraCount > 0 && (
        <Box
          sx={{
            position: "absolute",
            top: "50%", // Centered overlay
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60px",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            color: "white",
            fontSize: 18,
            fontWeight: 600,
            borderRadius: "50%", // Circular badge
          }}
        >
          +{extraCount}
        </Box>
      )}
    </Box>
  );
};

const EventDetails = ({ event, setVisibleEventId }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [handleAllMembersClick, setHandleAllMembersClick] = useState(false);
  const userId = userData ? userData.id : null;
  const [eventDetails] = useEventDetailMutation();
  const [eventData, setEventData] = useState(null);
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [eventId, setEventId] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [bookings, setBookings] = useState([]);
  const [ticketTypeQuantities, setTicketTypeQuantities] = useState({});
  const [totalTicketsBooked, setTotalTicketsBooked] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [handleInviteClick, setHandleInviteClick] = useState(false);
  const [handleReferralClick, setHandleReferralClick] = useState(false);
  const [totalTicketsSold, setTotalTicketsSold] = useState();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [invitationData, setInvitationData] = useState([]);
  const [referralData, setReferralData] = useState([]);
  const [referralUsers, setReferralUsers] = useState([]);
  const fetchEventDetails = async () => {
    if (event?.eventId) {
      try {
        const response = await eventDetails({
          eventId: event?.eventId,
        }).unwrap();

        const eventResponse = response?.event;
        setReferralUsers(response?.referralStats?.invitedUsers);
        setReferralData(response?.referralStats);
        setTotalTicketsSold(response?.totalTicketsBooked);
        setEventData(eventResponse);
        setDescription(eventResponse?.description || "");
        setName(eventResponse?.eventName || "");
        setDate(eventResponse?.date || "");
        setTime(
          eventResponse?.startDateTime
            ? dayjs(eventResponse.startDateTime).format("MM/DD/YYYY hh:mm A")
            : ""
        );
        setEndTime(
          eventResponse?.endDateTime
            ? dayjs(eventResponse.endDateTime).format("MM/DD/YYYY hh:mm A")
            : ""
        );
        setBookings(eventResponse?.bookings || []);
        setEventId(eventResponse?.eventId || "");

        const ticketQuantities = {};
        let totalTickets = 0;
        let totalAmountSum = 0;

        const ticket = eventResponse?.ticket ? eventResponse?.ticket[0] : null;

        if (ticket) {
          ticket.subTickets.forEach((subTicket) => {
            if (subTicket.ticketType?.typeName)
              ticketQuantities[subTicket.ticketType.typeName] =
                subTicket.quantity;
          });
        }

        const newData = eventResponse?.bookings.map((booking) => {
          const validTicketTypes = booking.ticketTypes.filter(
            (ticket) => ticket.quantity > 0
          );

          const totalTicketsInBooking = validTicketTypes.reduce(
            (sum, ticket) => sum + ticket.quantity,
            0
          );
          const ticketType = validTicketTypes
            .map((ticket) => ticket.type)
            .join(", ");
          booking.payments.forEach((payment) => {
            totalAmountSum += payment.amount;
          });

          return {
            key: booking.id.toString(),
            memberName: booking.buyer.fullName,
            role: "Participant",
            email: booking.buyer.email,
            phoneNumber: booking.buyer.phoneNumber,
            soldTickets: totalTicketsInBooking,
            ticketType: ticketType,
            booked: totalTicketsInBooking.toString(),
          };
        });
        setData(newData);
        setTicketTypeQuantities(ticketQuantities);
        setTotalTicketsBooked(totalTickets);
        setTotalAmount(totalAmountSum);

        const newInvitationData = (eventResponse?.TeamInvitations || []).map(
          (invitation) => ({
            key: invitation.invitationId.toString(),
            memberEmail: invitation.email,
            memberName:
              invitation.invitedName.charAt(0).toUpperCase() +
              invitation.invitedName.slice(1),
            status:
              invitation.status.charAt(0).toUpperCase() +
              invitation.status.slice(1),
            role: invitation.roleId === 2 ? "Team Member" : "Participant",
          })
        );

        setInvitationData(newInvitationData);
      } catch (error) {
        console.error("Failed to fetch event details:", error);
      }
    } else {
      console.log("No event ID exists");
    }
  };
  const encodedId = btoa(userId.toString());
  const copyInviteLink = () => {
    navigator.clipboard.writeText(
      `https://gxtickets.com/event-detailDesc/${event?.eventId}?sender=${encodedId}`
    );
    notification.success({
      message: "Copied to clipboard",
    });
  };

  useEffect(() => {
    fetchEventDetails();
  }, [event, eventDetails]);
  const images = eventData?.eventPhoto || [];
  const cardData = Object.entries(ticketTypeQuantities).map(
    ([title, value]) => ({
      title,
      value,
    })
  );

  if (!event) return null;
  return (
    <>
      <Box sx={{ marginTop: "1rem", paddingLeft: "16px" }}>
        <Button
          onClick={() => {
            setVisibleEventId(null);
          }}
        >
          <ArrowBackIcon /> Back
        </Button>
      </Box>
      <Grid container spacing={2} p={2}>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={1}
            sx={{
              borderRadius: 3,
              padding: 1.5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: 125,
            }}
          >
            <Typography sx={AllTypoFontStyles.CommonCardsTitleTypo}>
              Tickets Sold
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Grid>
                <TicketsSoldIcon />
              </Grid>
              <Typography sx={AllTypoFontStyles.CommonCardsValueTypo}>
                {totalTicketsSold}
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={1}
            sx={{
              borderRadius: 3,
              padding: 1.5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: 125,
            }}
          >
            <Typography sx={AllTypoFontStyles.CommonCardsTitleTypo}>
              Total Earned
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Grid>
                <CommissionEarnedIcon />
              </Grid>
              <Typography sx={AllTypoFontStyles.CommonCardsValueTypo}>
                {/* ${totalAmount} */}${(totalAmount * 0.9).toFixed(1)}
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={1}
            sx={{
              borderRadius: 3,
              padding: 1.5,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: 125,
            }}
          >
            <Typography sx={AllTypoFontStyles.CommonCardsTitleTypo}>
              Tickets Sold Via My Link
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Grid>
                <CommissionEarnedIcon />
              </Grid>
              <Typography sx={AllTypoFontStyles.CommonCardsValueTypo}>
                {/* ${(totalAmount * 0.9).toFixed(1)} */}
                {referralData?.totalTicketsViaReferrals}
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={3}
            onClick={() => {
              navigate("/QRCode-upload", { state: { eventId, userId } });
            }}
            sx={{
              position: "relative",
              borderRadius: 4,
              padding: 2,
              overflow: "hidden",
              background: "linear-gradient(135deg, #061F44, #0A2A66)",
              cursor: "pointer",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              height: "125px",
              "&:hover": {
                transform: "scale(1.03)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
              },
            }}
          >
            {/* Subtle shimmer bg */}
            <Box
              sx={{
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
                backgroundImage:
                  "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.05), transparent), radial-gradient(circle at 70% 70%, rgba(255,255,255,0.03), transparent)",
                zIndex: 1,
              }}
            />

            {/* Content */}
            <Box
              sx={{
                position: "relative",
                zIndex: 2,
                color: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <QrCodeScannerIcon
                sx={{ fontSize: 42, color: "#ffffff", opacity: 0.9 }}
              />
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, letterSpacing: 0.5 }}
              >
                Scan Tickets
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                Tap to start scanning
              </Typography>
            </Box>

            {/* Pulse effect */}
            <Box
              sx={{
                position: "absolute",
                bottom: 12,
                right: 12,
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: "#00FFB3",
                boxShadow: "0 0 10px 4px rgba(0,255,179,0.4)",
                animation: "pulse 1.5s infinite",
                zIndex: 2,
              }}
            />

            {/* Keyframe animation */}
            <style>
              {`
        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 0.9;
          }
          50% {
            transform: scale(1.4);
            opacity: 0.4;
          }
          100% {
            transform: scale(1);
            opacity: 0.9;
          }
        }
      `}
            </style>
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={2} p={2}>
        <Grid item xs={12} md={8}>
          <Paper
            sx={{
              p: 3,
              width: "100%",
              borderRadius: 3,
              backgroundColor: "#ffffff",
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            }}
          >
            {/* Event Name */}
            <Box
              sx={{
                mb: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                rowGap: 1,
                columnGap: 2,
                alignItems: { sm: "center" },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 15,
                  color: "#142E56",
                  minWidth: "140px",
                }}
              >
                Event Name:
              </Typography>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 15,
                  wordBreak: "break-word",
                  flex: 1,
                }}
              >
                {name}
              </Typography>
            </Box>

            {/* Description */}
            <Box
              sx={{
                mb: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                rowGap: 1,
                columnGap: 2,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 15,
                  color: "#142E56",
                  minWidth: "140px",
                }}
              >
                Description:
              </Typography>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 15,
                  textAlign: "justify",
                  wordBreak: "break-word",
                  flex: 1,
                }}
              >
                {description}
              </Typography>
            </Box>

            {/* Start Date */}
            <Box
              sx={{
                mb: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                rowGap: 1,
                columnGap: 2,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 15,
                  color: "#142E56",
                  minWidth: "140px",
                }}
              >
                Event Start:
              </Typography>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 15,
                  wordBreak: "break-word",
                  flex: 1,
                }}
              >
                {time}
              </Typography>
            </Box>

            {/* End Date */}
            <Box
              sx={{
                mb: 2,
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                rowGap: 1,
                columnGap: 2,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 15,
                  color: "#142E56",
                  minWidth: "140px",
                }}
              >
                Event End:
              </Typography>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: 15,
                  wordBreak: "break-word",
                  flex: 1,
                }}
              >
                {endTime}
              </Typography>
            </Box>

            {/* Participants */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                rowGap: 1,
                columnGap: 2,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: 15,
                  color: "#142E56",
                  minWidth: "140px",
                }}
              >
                Participants:
              </Typography>
              <Typography sx={{ fontWeight: 500, fontSize: 15, flex: 1 }}>
                {data.length > 1
                  ? `${data.length} Members`
                  : `${data.length === 0 ? "No" : data.length} Member`}
              </Typography>
            </Box>

            {/* Optional Table */}
            {/* {data.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          scroll={{ y: 230, x: "max-content" }}
        />
      </Box>
    )} */}
          </Paper>
        </Grid>

        <Grid item md={4}>
          <Paper sx={{ padding: 2, width: "100%" }}>
            <Grid container spacing={2} sx={{ width: "100%" }}>
              {cardData?.length > 0 && (
                <Typography
                  sx={{
                    ...AllTypoFontStyles.CommonCardsTitleTypo,
                    pl: 2,
                    pt: 1,
                  }}
                >
                  Total Ticket Quantities
                </Typography>
              )}
              {cardData?.map((card, index) => (
                <Grid item xs={12} key={index}>
                  <StatCard title={card.title} value={card.value} />
                </Grid>
              ))}

              {images.length > 0 ? (
                <ImageGrid images={images} />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: { md: "2rem", xs: "0rem" },
                    mt: { md: "1rem", xs: "1rem" },
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: 14,
                      marginBottom: "0.8rem",
                      textAlign: "center",
                    }}
                  >
                    No images available
                  </Typography>
                </Box>
              )}
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 1,
              }}
            >
              <Box sx={{ gap: 1, display: "flex" }}>
                <Button
                  style={{ marginBottom: 10 }}
                  onClick={() => {
                    setHandleAllMembersClick(!handleAllMembersClick);
                    setHandleInviteClick(false);
                    setHandleReferralClick(false);
                  }}
                >
                  All Participants
                </Button>
                <Button
                  style={{ marginBottom: 10 }}
                  onClick={() => {
                    setHandleInviteClick(!handleInviteClick);
                    setHandleReferralClick(false);
                    setHandleAllMembersClick(false);
                  }}
                >
                  Team Members
                </Button>
              </Box>
              <Box sx={{ gap: 1, display: "flex" }}>
                <Button
                  style={{ marginBottom: 10 }}
                  onClick={() => {
                    setHandleReferralClick(!handleReferralClick);
                    setHandleInviteClick(false); // Hide the invited members table when toggling referral users table
                    setHandleAllMembersClick(false);
                  }}
                >
                  My Referrals
                </Button>
                <Button style={{ marginBottom: 10 }} onClick={copyInviteLink}>
                  Copy Referral Link
                </Button>
              </Box>
            </Box>
            {handleInviteClick && (
              <Grid item xs={12} md={8}>
                {invitationData.length > 0 ? (
                  <Paper>
                    <Box
                      sx={{
                        width: "100%",
                        padding: 2,
                        borderRadius: 2,
                      }}
                    >
                      <Table
                        scroll={{ y: 230, x: "auto" }}
                        dataSource={invitationData}
                        columns={invitationColumn}
                        pagination={false}
                      />
                    </Box>
                  </Paper>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: { md: "2rem", xs: "0rem" },
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: 14,
                        marginBottom: "1rem",
                      }}
                    >
                      No Invited Members
                    </Typography>
                  </Box>
                )}
              </Grid>
            )}
            {/* Show Referral Users Table */}
            {handleReferralClick && (
              <Grid item xs={12} md={8}>
                {referralUsers.length > 0 ? (
                  <Paper sx={{ borderRadius: 2 }}>
                    <Table
                      dataSource={referralUsers}
                      columns={referralColumns}
                      pagination={false}
                      scroll={{ y: 230, x: "max-content" }}
                    />
                  </Paper>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Typography sx={{ fontWeight: 400, fontSize: 14 }}>
                      No Users Found for Your Referral Link
                    </Typography>
                  </Box>
                )}
              </Grid>
            )}
            {handleAllMembersClick && (
              <Grid item xs={12} md={8}>
                {data.length > 0 ? (
                  <Paper sx={{ padding: 2, borderRadius: 2 }}>
                    <Table
                      dataSource={data}
                      columns={columns}
                      pagination={false}
                      scroll={{ y: 230, x: "max-content" }}
                    />
                  </Paper>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Typography sx={{ fontWeight: 400, fontSize: 14 }}>
                      No Members Found
                    </Typography>
                  </Box>
                )}
              </Grid>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* <Box sx={{ height: "5vh" }}></Box> */}
      {/* <ScanButton eventId={eventId} userId={userId} styleProp="20px" /> */}
    </>
  );
};

export default EventDetails;
